import React, { useImperativeHandle, useState } from "react";
import {
  CCol,
  CDataTable,
  CRow,
  CCardHeader,
  CButton,
  CLabel,
  CInput,
  CForm,
} from "@coreui/react";
import { formatDate } from "src/shared/Format/dateFormat";
import { Paper } from "@mui/material";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/system";
import { apiCall, downloadUrl } from "src/_apiConfig/apiCall";
import { useHistory } from "react-router-dom";
import ConfirmationPopup from "../common/ConfirmationPopup";
//import Auth from "src/auth";
//import { number } from "prop-types";

//var hash = require("object-hash");

const CommonList = React.forwardRef((props, ref) => {
  const Backdrop = styled("div")`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-tap-highlight-color: transparent;
  `;
  //Popup
  const [deletedocumentopen, setdeletedocumentopen] = useState(false);
  const [deletedocumentid, setdeletedocumentid] = useState(false);

  const handleDeleteDocumentOpen = (id) => {
    setdeletedocumentopen(true);
    setdeletedocumentid(id);
  };

  const handleeDeleteDocumentClose = () => setdeletedocumentopen(false);

  // eslint-disable-next-line no-unused-vars
  const [loading, setloading] = useState(false);
  const [selectedArr, setselectedArr] = useState([]);
  const [selectedObj, setselectedObj] = useState([]);
  const [startNo, setstartNo] = useState();
  const [date, setdate] = useState();
  const [agreementdate, setagreementdate] = useState();
  // eslint-disable-next-line no-unused-vars
  const [paymentUrl, setpaymentUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [agreementopen, setAgreementOpen] = useState(false);
  const [bgapproveopen, setbgapproveopen] = useState(false);
  const [bgrejectopen, setbgrejectopen] = useState(false);
  const [actualbagopen, setactualbagopen] = useState(false);
  const [actualbaglotid, setactualbaglotid] = useState(false);
  const [actualbagQty, setactualbagQty] = useState(0);
  const [actualbagLotNo, setactualbagLotNo] = useState(0);
  const [actualbagGodownRent, setactualbagGodownRent] = useState(0);
  const [actualbagGodownRentTotal, setactualbagGodownRentTotal] = useState(0);
  const [isPaidActualGodownRent, setisPaidActualGodownRent] = useState(false);
  const [agreementTenderId, setagreementTenderId] = useState();
  const [lotpaymentid, setlotpaymentid] = useState();
  const [isTransferLotBG, setisTransferLotBG] = useState();
  const [sanctionTenderId, setsanctionTenderId] = useState();
  //const [transmsg, settransmsg] = useState();
  const history = useHistory();
  //const { authenticated } = Auth();
  const [agreementextendOpen, setagreementextendOpen] = useState(false);
  const [agreementextendrejectOpen, setagreementextendrejectOpen] =
    useState(false);
  const [agreementextendlotid, setagreementextendlotid] = useState();
  const [agreementextendpaymentid, setagreementextendpaymentid] = useState();

  //const [isShow, setisShow] = useState(false);
  //const [lotlistDataBag, setlotlistDataBag] = useState();
  //const [lotSelectionItems, setlotSelectionItems] = useState([]);
  const [ABSBGPaymentId, setABSBGPaymentId] = useState();
  // popup Start
  // const [refundopen, setrefundopen] = useState(false);
  // const [refundLotNo, setrefundLotNo] = useState(0);

  //const [refundStatusList, setrefundStatusList] = useState(false);
  //Popup End

  // const DownloadTransferLetter = async (lotid) => {
  //   const header = new Headers();
  //   const response = await apiCall(
  //     `LotDetails/DownloadTransferLetter?lotid=${Number(lotid)}`,
  //     "GET",
  //     header,
  //     null
  //   );

  //   const jsonobj = await response;
  //   if (jsonobj.status === 200) {
  //     jsonobj.blob().then((blob) => {
  //       const fileURL = window.URL.createObjectURL(blob);
  //       // Setting various property values
  //       let alink = document.createElement("a");
  //       alink.href = fileURL;
  //       alink.download = lotid + ".pdf";
  //       alink.click();
  //     });
  //   }
  // };

  // const showbtn = (isAllowToCCFDeleteTheBidderAgreement, filename) => {
  //   if (
  //     isAllowToCCFDeleteTheBidderAgreement &&
  //     filename.toLowerCase().includes("signed_")
  //   ) {
  //     setisShow(false);
  //     console.log("isShow: cadfasf asdf asdf a" + isShow);
  //   } else {
  //     setisShow(true);
  //   }
  // };

  const handleApproveExtendClose = () => setagreementextendOpen(false);
  const handleRejectExtendClose = () => setagreementextendrejectOpen(false);
  const handleRejectCOfirmationClose = () => setbgrejectopen(false);

  const handleApproveExtendOpen = (id, paymentId) => {
    setagreementextendOpen(true);
    setagreementextendlotid(id);
    setagreementextendpaymentid(paymentId);
  };

  const handleRejectExtendOpen = (id, paymentId) => {
    setagreementextendrejectOpen(true);
    setagreementextendlotid(id);
    setagreementextendpaymentid(paymentId);
  };

  const handleRejectCOfirmationOpen = async (
    id,
    isTransferLotBG,
    PaymentId
  ) => {
    setbgrejectopen(true);
    setlotpaymentid(id);
    setisTransferLotBG(isTransferLotBG);
    setABSBGPaymentId(PaymentId);
  };
  // const handleviewBidderDetails = async (id) => {
  //   alert(id);
  // };
  const handleApproveCOfirmationOpen = async (
    id,
    isTransferLotBG,
    paymentId
  ) => {
    setbgapproveopen(true);
    setlotpaymentid(id);
    setisTransferLotBG(isTransferLotBG);
    setABSBGPaymentId(paymentId);
  };
  const handleApproveCOfirmationClose = () => setbgapproveopen(false);

  // const handleDownloadSanctionLetterByBidder = async (tenderid, userId) => {
  //   const header = new Headers();
  //   const response = await apiCall(
  //     `Bidder/DownloadBidderSanction?tenderId=${Number(
  //       tenderid
  //     )}&userId=${Number(userId)}`,
  //     "GET",
  //     header,
  //     null
  //   );

  //   const jsonobj = await response;
  //   jsonobj.blob().then((blob) => {
  //     const fileURL = window.URL.createObjectURL(blob);
  //     // Setting various property values
  //     let alink = document.createElement("a");
  //     alink.href = fileURL;
  //     alink.download = tenderid + "" + userId + ".pdf";
  //     alink.click();
  //   });
  // };
  // const TenderClickHandler = async (path, id, mode) => {
  //   history.push(`/${path}/${id}/${mode}`, {
  //     from: window.location.href,
  //   });
  // };

  // const getTenderDetails = async (lotid) => {
  //   setloading(true);
  //     const header = new Headers();
  //     const response = await apiCall(
  //       `LotDetails/IsPaidGodownRent?lotid=${Number(lotid)}`,
  //       "GET",
  //       header,
  //       null
  //     );
  //     const jsonobj = await response.json();
  //     if (response.status === 200) {
  //       setactualbagQty(jsonobj);
  //
  //     }
  //     setloading(false);
  // };

  const getIsGRAmountPaid = async (lotid, bags, lotno, godownrent) => {
    setloading(true);
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/IsPaidGodownRent?lotid=${Number(lotid)}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200) {
      setisPaidActualGodownRent(jsonobj);

      setactualbagopen(true);
      setactualbagQty(bags);
      setactualbaglotid(lotid);
      setactualbagLotNo(lotno);
      setactualbagGodownRent(godownrent);
      let total = godownrent * bags;
      setactualbagGodownRentTotal(total);
    }
    setloading(false);
  };
  // const testhandle = (id) => {
  //   alert(id);
  // };
  // for popup START
  const handleActualBagPopupOpen = (lotid, bags, lotno, godownrent) => {
    getIsGRAmountPaid(lotid, bags, lotno, godownrent);
  };

  const handleActualBagClose = () => setactualbagopen(false);

  //popup END

  // for popup START
  const handleDownloadParidhanAadesh = async (lotid, lotPaymentId) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/DownloadParidhanAadeshNew?lotid=${Number(
        lotid
      )}&lotpaymentid=${Number(lotPaymentId)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    jsonobj.blob().then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      // Setting various property values
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = lotid + "_" + lotPaymentId + ".pdf";
      alink.click();
    });
  };

  // const getRefundStatus = async (lotno) => {
  //   setloading(true);
  //   const header = new Headers();
  //   const response = await apiCall(
  //     `LotTransfer/GetRefundStatus`,
  //     "GET",
  //     header,
  //     null
  //   );
  //   const jsonobj = await response.json();
  //   if (response.status === 200) {
  //     setrefundStatusList(jsonobj);

  //     setloading(false);
  //   }
  // };

  // const handleRefundPopupOpen = (lotno) => {
  //   setrefundopen(true);
  //   setrefundLotNo(lotno);
  //   getRefundStatus(lotno);
  // };

  // const handleRefundPopupClose = () => setrefundopen(false);

  //popup END

  const calculateTotalRent = (qty) => {
    setactualbagQty(qty);
    let total = actualbagGodownRent * qty;
    setactualbagGodownRentTotal(total);
  };

  const handleOpen = (id) => {
    setsanctionTenderId(id);
    setOpen(true);
  };

  const handleViewSanctionLatters = (id) => {
    history.push(`/ViewSanctionLatter/${id}`, {
      from: window.location.href,
    });
  };
  const handleClose = () => setOpen(false);
  const handleAgreementOpen = (id) => {
    setAgreementOpen(true);
    setagreementTenderId(id);
  };
  const handleAgreementClose = () => setAgreementOpen(false);

  // function makeid(length) {
  //   var result = "";
  //   var characters =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   var charactersLength = characters.length;
  //   for (var i = 0; i < length; i++) {
  //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  //   }
  //   return result;
  // }
  const PaymentHanlder = async (lotId, amount) => {
    history.push(`/submitpayment/${lotId}/${amount}`, {
      from: window.location.href,
    });
  };

  const BGPaymentStatusViewHanlder = async (filePath) => {
    const header = new Headers();
    const response = await apiCall(
      `Report/DownloadBGReceipt?filepath=${filePath}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response;

    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = filePath;
        alink.click();
      });
    } else {
      alert("Receipt not availabe");
    }
  };

  const PaymentStatusViewHanlder = async (tranid) => {
    const header = new Headers();
    const response = await apiCall(
      `Report/DownloadReceipt?txnId=${tranid}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;

    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = tranid + ".pdf";
        alink.click();
      });
    } else {
      alert("Receipt not availabe");
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderRadius: "4px",
    fontSize: "1rem",
    padding: "2rem",
  };
  useImperativeHandle(ref, () => ({
    setFindArrResult() {
      setFindArrResult();
    },
  }));
  const setFindArrResult = () => {
    setselectedArr([]);
    setselectedObj([]);
  };

  const approveExtendAgreementClick = (e) => {
    //e.preventDefault();
    handleApproveExtendClose();
    props.approved(agreementextendlotid, agreementextendpaymentid);
  };

  const rejectExtendAgreementClick = () => {
    //e.preventDefault();
    handleRejectExtendClose();
    props.reject(agreementextendlotid, agreementextendpaymentid);
  };

  const approveBGClick = (e) => {
    //e.preventDefault();
    handleApproveCOfirmationClose();
    props.approveBG(lotpaymentid, isTransferLotBG, ABSBGPaymentId);
  };
  const rejectBGClick = () => {
    //e.preventDefault();
    handleRejectCOfirmationClose();
    props.rejectBG(lotpaymentid, isTransferLotBG, ABSBGPaymentId);
  };
  return (
    <>
      <CCardHeader>
        {/* className="mb-5 pt-3" */}
        <CRow xl={12} className="mt-2">
          {/* className="mt-3" */}
          <CCol xl={10}>
            <h3>{props.listName}</h3>
          </CCol>
        </CRow>
        <hr />
        {props.additional}
        <CRow className="mt-3 ">
          <CCol xl={12}>
            <CDataTable
              items={props.items}
              fields={props.fields}
              hover
              addTableClasses="table table-striped"
              responsive
              border
              loading={props.loading}
              itemsPerPage={3}
              scopedSlots={{
                show_details: (item, index) => {
                  let id;
                  if (props.path === "/lotlistview/") {
                    id = window.btoa(item[props.id]);
                  } else {
                    id = item[props.id];
                  }
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        to={props.path + id}
                        color="success"
                      >
                        {props.tabBtn}
                      </CButton>
                    </td>
                  );
                },

                // show_transfer_lot_details: (item, index) => {
                //   let id;
                //   if (props.path === "/transferlotdetails/") {
                //     id = window.btoa(item[props.id]);
                //   } else {
                //     id = item[props.id];
                //   }
                //   return (
                //     <td className="py-2">
                //       <CButton
                //         variant="outline"
                //         shape="square"
                //         size="sm"
                //         to={props.path + id}
                //         color="success"
                //       >
                //         {props.tabBtn}
                //       </CButton>
                //     </td>
                //   );
                // },
                // download_transfer_lot_details: (item, index) => {
                //   // let id;
                //   // if (props.path === "/transferlotdetails/") {
                //   //   id = window.btoa(item[props.id]);
                //   // } else {
                //   //   id = item[props.id];
                //   // }
                //   return (
                //     <td className="py-2">
                //       <CButton
                //         variant="outline"
                //         shape="square"
                //         size="sm"
                //         hidden={
                //           item.statusId === 1 &&
                //           item.isCCFSignedAgreement === true
                //             ? false
                //             : true
                //         }
                //         onClick={() => DownloadTransferLetter(item.lotId)}
                //         color="success"
                //       >
                //         Download Transfer Letter
                //       </CButton>
                //     </td>
                //   );
                // },
                // Refund_History: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <>
                //         <CButton
                //           variant="outline"
                //           shape="square"
                //           size="sm"
                //           color="success"
                //           onClick={() => {
                //             props.ShowRefundHistory(item.lotNo);
                //           }}
                //         >
                //           View Refund Status
                //         </CButton>
                //       </>
                //     </td>
                //   );
                // },
                ShowCheckBox: (lotItm, index) => {
                  let lotId = lotItm["lotId"];
                  var findArrResult = selectedArr.find(
                    (data) => lotId === data
                  );

                  const checkedFun = () => {
                    let idArr = selectedArr;
                    let idObj = selectedObj;
                    let findResult = selectedArr.find((data) => lotId === data);
                    if (findResult) {
                      idArr = idArr.filter((data) => lotId !== data);
                      setselectedArr(idArr);
                      props.selectLot(idArr);
                      idObj = idObj.filter(
                        (data) => lotItm["lotId"] !== data.lotId
                      );
                      setselectedObj(idObj);
                      props.selectLotObj(idObj);
                    } else {
                      idArr.push(lotId);
                      idObj.push(lotItm);
                      setselectedObj(idObj);
                      setselectedArr(idArr);
                      props.selectLot(idArr);
                      props.selectLotObj(idObj);
                    }
                  };

                  return (
                    <td className="py-2">
                      <input
                        type="checkbox"
                        checked={findArrResult}
                        onChange={checkedFun}
                      />
                    </td>
                  );
                },
                EditionInRow: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.status === true ? "active" : "inactive"}
                      </span>
                    </td>
                  );
                },
                paDateFormat: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.paridhanAadeshDate === null
                          ? ""
                          : formatDate(item.paridhanAadeshDate)}
                      </span>
                    </td>
                  );
                },
                // paymentDateFormat: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <span>
                //         {item.paymentDateTime === null
                //           ? ""
                //           : formatDate(item.paymentDateTime)}
                //       </span>
                //     </td>
                //   );
                // },
                // paymentSuccessDateFormat: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <span>
                //         {item.paymentSuccessDate === null
                //           ? ""
                //           : formatDate(item.paymentSuccessDate)}
                //       </span>
                //     </td>
                //   );
                // },
                inserdateformat: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.insertDateTime === null
                          ? ""
                          : formatDate(item.insertDateTime)}
                      </span>
                    </td>
                  );
                },

                BGDueDateormat: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.bgDueDate === null
                          ? ""
                          : formatDate(item.bgDueDate)}
                      </span>
                    </td>
                  );
                },
                dateFormat: (item, index) => {
                  const day = item.purchaseDate.substring(8, 10);
                  const month = item.purchaseDate.substring(5, 7);
                  const year = item.purchaseDate.substring(0, 4);
                  return (
                    <td className="py-2">
                      <span>{`${day}-${month}-${year}`}</span>
                    </td>
                  );
                },
                LeasePDate: (item, index) => {
                  const day = item.leasePeriodDate.substring(8, 10);
                  const month = item.leasePeriodDate.substring(5, 7);
                  const year = item.leasePeriodDate.substring(0, 4);
                  return (
                    <td className="py-2">
                      <span>{`${day}-${month}-${year}`}</span>
                    </td>
                  );
                },
                BGDueDate: (item, index) => {
                  const day = item.dueDate.substring(8, 10);
                  const month = item.dueDate.substring(5, 7);
                  const year = item.dueDate.substring(0, 4);
                  return (
                    <td className="py-2">
                      <span>{`${day}-${month}-${year}`}</span>
                    </td>
                  );
                },
                // CanModify: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <span>{item.canModified ? "Yes" : "No"}</span>
                //     </td>
                //   );
                // },
                // displayPaymentType: (item, index) => {
                //   //const prefix = item.responseMessage.substring(0, 3);

                //   return (
                //     <td className="py-2">
                //       <span>
                //         {item.responseMessage.endsWith("--1")
                //           ? "Security Deposit"
                //           : item.responseMessage.endsWith("--2")
                //           ? "Full Lot Payment"
                //           : item.responseMessage.endsWith("--3")
                //           ? "Additional Security Deposit"
                //           : item.responseMessage.substring(0, 3) === "LT-"
                //           ? "Lot Payment"
                //           : item.responseMessage.substring(0, 3) === "FT-"
                //           ? "Lot Transfer Fees"
                //           : item.responseMessage.substring(0, 3) === "Tra"
                //           ? "Security Deposit - Transferred"
                //           : item.responseMessage.substring(0, 3) === "GR-"
                //           ? "Godown Rent"
                //           : item.responseMessage.substring(0, 3) === "GRE"
                //           ? "Godown Rent Fee Extension"
                //           : item.responseMessage.substring(0, 3) === "Agr"
                //           ? "Agreement Extension Fees"
                //           : "Other"}
                //       </span>
                //     </td>
                //   );
                // },
                // displayInstallmentNumber: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <span>
                //         {item.paymentComplete === "25"
                //           ? "First Installment"
                //           : item.paymentComplete === "50"
                //           ? "Second Installemnt"
                //           : item.paymentComplete === "75"
                //           ? "Third Installment"
                //           : item.paymentComplete === "100"
                //           ? "Fourth Installment"
                //           : ""}
                //       </span>
                //     </td>
                //   );
                // },
                displayInstallment: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.paymentComplete === "25"
                          ? "First Installment"
                          : item.paymentComplete === "50"
                          ? "Second Installemnt"
                          : item.paymentComplete === "75"
                          ? "Third Installment"
                          : item.paymentComplete === "100"
                          ? "Fourth Installment"
                          : "Full Payment"}
                      </span>
                    </td>
                  );
                },
                District: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.disctrict === null ? "" : item.disctrict}
                      </span>
                    </td>
                  );
                },
                City: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>{item.city === null ? "" : item.city}</span>
                    </td>
                  );
                },
                CollectionSession: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.collectionSeason === null
                          ? ""
                          : item.collectionSeason}
                      </span>
                    </td>
                  );
                },
                Street: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.streetName === null ? "" : item.streetName}
                      </span>
                    </td>
                  );
                },
                ConditionalBtn: (item, index) => {
                  return (
                    <td className="py-2">
                      {!item.isSanctionLetterGenerated ? (
                        <CButton
                          variant="outline"
                          shape="square"
                          size="sm"
                          to={props.path + item[props.id] + "/edit"}
                          // onClick={() =>
                          //   TenderClickHandler(
                          //     props.path,
                          //     item[props.id],
                          //     "edit"
                          //   )
                          // }
                          color="success"
                        >
                          {props.tabBtn}
                        </CButton>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                },
                ViewTenderBtn: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        to={props.path + item[props.id] + "/view"}
                        // onClick={() =>
                        //   TenderClickHandler(props.path, item[props.id], "view")
                        // }
                        color="success"
                      >
                        View
                      </CButton>
                    </td>
                  );
                },
                // EditBtn: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <CButton
                //         variant="outline"
                //         shape="square"
                //         size="sm"
                //         to={props.path + item[props.id]}
                //         color="success"
                //       >
                //         {props.tabBtn}
                //       </CButton>
                //     </td>
                //   );
                // },
                GenerateLetter: (item, index) => {
                  return (
                    <td className="py-2">
                      {item.isSanctionLetterGenerated ? (
                        <CButton
                          variant="outline"
                          shape="square"
                          size="sm"
                          color="success"
                          disabled={props.disableApproveReject}
                          // to={props.seccpath + item[props.id]}
                          onClick={() =>
                            handleViewSanctionLatters(item.tenderId)
                          }
                        >
                          View Sanction Letters
                        </CButton>
                      ) : (
                        <>
                          <CButton
                            variant="outline"
                            shape="square"
                            size="sm"
                            color="success"
                            disabled={props.disableApproveReject}
                            // to={props.seccpath + item[props.id]}
                            onClick={() => handleOpen(item.tenderId)}
                          >
                            Generate Sanction Letter
                          </CButton>
                          <div>
                            <Modal
                              open={open}
                              onClose={handleClose}
                              aria-labelledby="modal-modal-title"
                              aria-describedby="modal-modal-description"
                              BackdropComponent={Backdrop}
                            >
                              <Paper style={style} elevation={3}>
                                <CForm
                                  className="needs-validation"
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                    handleClose();
                                    props.generateBtn(
                                      sanctionTenderId,
                                      startNo,
                                      date
                                    );
                                  }}
                                >
                                  <CRow>
                                    <CCol>
                                      <CLabel>Start No:</CLabel>
                                      <CInput
                                        type="number"
                                        onChange={(e) =>
                                          setstartNo(e.target.value)
                                        }
                                        min="1"
                                        required
                                      />
                                    </CCol>
                                  </CRow>
                                  <CRow className="mt-2">
                                    <CCol>
                                      <CLabel>Date:</CLabel>
                                      <CInput
                                        type="date"
                                        onChange={(e) =>
                                          setdate(e.target.value)
                                        }
                                        required
                                      />
                                    </CCol>
                                  </CRow>
                                  <CRow
                                    style={{
                                      marginLeft: "7rem",
                                    }}
                                  >
                                    <CCol>
                                      <CButton
                                        className="mt-3"
                                        color="success"
                                        type="submit"
                                      >
                                        Generate
                                      </CButton>
                                    </CCol>
                                  </CRow>
                                </CForm>
                              </Paper>
                            </Modal>
                          </div>
                        </>
                      )}
                    </td>
                  );
                },
                AddActualBag: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="success"
                        // to={props.seccpath + item[props.id]}
                        onClick={() =>
                          handleActualBagPopupOpen(
                            item.lotId,
                            item.actualbags,
                            item.lotNo,
                            item.godownrent
                          )
                        }
                      >
                        Add Actual Bag
                      </CButton>
                      <div>
                        <Modal
                          open={actualbagopen}
                          onClose={handleActualBagClose}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                          BackdropComponent={Backdrop}
                        >
                          <Paper style={style} elevation={3}>
                            <CForm
                              className="needs-validation"
                              onSubmit={(e) => {
                                e.preventDefault();
                                handleActualBagClose();
                                props.addActualBag(
                                  actualbaglotid,
                                  actualbagQty
                                );
                              }}
                            >
                              <CRow>
                                <CCol>
                                  <CLabel>Lot No:</CLabel>
                                  <CLabel className="ml-2">
                                    {actualbagLotNo}{" "}
                                  </CLabel>
                                </CCol>
                              </CRow>
                              <CRow>
                                <CCol>
                                  <CLabel>Godown Rent:</CLabel>
                                  <CLabel className="ml-2">
                                    {actualbagGodownRent}{" "}
                                  </CLabel>
                                </CCol>
                              </CRow>
                              <CRow>
                                <CCol>
                                  <CLabel>Actual Bags:</CLabel>
                                  <CInput
                                    type="text"
                                    value={actualbagQty}
                                    onChange={(e) =>
                                      //calculateTotalRent(e.target.value)
                                      !e.target.value ||
                                      e.target.value.match(
                                        /^\d{1,}(\.\d{0,2})?$/
                                      )
                                        ? calculateTotalRent(e.target.value)
                                        : ""
                                    }
                                    required
                                  />
                                </CCol>
                              </CRow>
                              <CRow>
                                <CCol>
                                  <CLabel>Total Rent:</CLabel>
                                  <CLabel className="ml-2 mt-2">
                                    {actualbagGodownRentTotal}{" "}
                                  </CLabel>
                                </CCol>
                              </CRow>
                              <CRow>
                                <CCol>
                                  <CButton
                                    className="mt-3"
                                    color="success"
                                    type="submit"
                                    disabled={isPaidActualGodownRent}
                                  >
                                    Add
                                  </CButton>
                                  <CButton
                                    className="mt-3 ml-2 btn btn-dark"
                                    color="success"
                                    type="button"
                                    onClick={() => handleActualBagClose()}
                                  >
                                    Close
                                  </CButton>
                                </CCol>
                              </CRow>
                            </CForm>
                          </Paper>
                        </Modal>
                      </div>
                    </td>
                  );
                },
                AgreementLetter: (item, index) => {
                  return (
                    <td className="py-2">
                      {item.isAgreementLetterGenerated ? (
                        ""
                      ) : (
                        <>
                          <CButton
                            variant="outline"
                            shape="square"
                            size="sm"
                            color="success"
                            disabled={props.disableApproveReject}
                            // to={props.seccpath + item[props.id]}
                            onClick={() => handleAgreementOpen(item.tenderId)}
                          >
                            Generate Agreement Letter
                          </CButton>
                          <div>
                            <Modal
                              open={agreementopen}
                              onClose={handleAgreementClose}
                              aria-labelledby="modal-modal-title"
                              aria-describedby="modal-modal-description"
                              BackdropComponent={Backdrop}
                            >
                              <Paper style={style} elevation={3}>
                                <CForm
                                  className="needs-validation"
                                  onSubmit={(e) => {
                                    e.preventDefault();
                                    handleAgreementClose();
                                    props.generateAgreement(
                                      agreementTenderId,
                                      agreementdate
                                    );
                                  }}
                                >
                                  <CRow>
                                    <CCol>
                                      <CLabel>Date:</CLabel>
                                      <CInput
                                        type="date"
                                        onChange={(e) =>
                                          setagreementdate(e.target.value)
                                        }
                                        required
                                      />
                                    </CCol>
                                  </CRow>
                                  <CRow
                                    style={{
                                      marginLeft: "7rem",
                                    }}
                                  >
                                    <CCol>
                                      <CButton
                                        className="mt-3"
                                        color="success"
                                        type="submit"
                                      >
                                        Generate
                                      </CButton>
                                    </CCol>
                                  </CRow>
                                </CForm>
                              </Paper>
                            </Modal>
                          </div>
                        </>
                      )}
                    </td>
                  );
                },
                TransferStatus: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.status === 0
                          ? "Pending"
                          : item.status === 1
                          ? "Approved"
                          : "Rejected"}
                      </span>
                    </td>
                  );
                },
                // TransferHOStatus: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <span>
                //         {item.hoStatus === null || item.hoStatus === undefined
                //           ? "Pending"
                //           : item.hoStatus === 1
                //           ? "Approved"
                //           : "Rejected"}
                //       </span>
                //     </td>
                //   );
                // },
                requestDateTime: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>{formatDate(item.requestDateTime)}</span>
                    </td>
                  );
                },
                requestUpdateDateTime: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>{formatDate(item.requestUpdateDateTime)}</span>
                    </td>
                  );
                },
                insertDateTime: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>{formatDate(item.insertDateTime)}</span>
                    </td>
                  );
                },
                dueDate: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>{formatDate(item.dueDate)}</span>
                    </td>
                  );
                },
                terminationDate: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>{formatDate(item.terminationDate)}</span>
                    </td>
                  );
                },
                userEmailId: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>{item.paidByUser.emailId}</span>
                    </td>
                  );
                },
                type: (item, index) => {
                  return (
                    <td className="py-2">
                      <span>
                        {item.type === 1 ? "Transfer" : "Lot Payment"}
                      </span>
                    </td>
                  );
                },
                // viewSanctionLetterByBidder: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <a
                //         target="_blank"
                //         href={`${downloadUrl}/${item.path}`}
                //         rel="noreferrer"
                //       >
                //         <CButton
                //           variant="outline"
                //           shape="square"
                //           size="sm"
                //           color="success"
                //         >
                //           View
                //         </CButton>
                //       </a>
                //     </td>
                //   );
                // },
                viewBG: (item, index) => {
                  return (
                    <td className="py-2">
                      <a
                        target="_blank"
                        href={`${downloadUrl}/${item.filePath}`}
                        rel="noreferrer"
                      >
                        <CButton
                          variant="outline"
                          shape="square"
                          size="sm"
                          color="success"
                        >
                          View
                        </CButton>
                      </a>
                    </td>
                  );
                },

                // approveABSBG: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <CButton
                //         variant="outline"
                //         shape="square"
                //         size="sm"
                //         color="success"
                //         disabled={props.disableApproveReject}
                //       >
                //         Approve
                //       </CButton>
                //     </td>
                //   );
                // },
                // rejectABSBG: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <CButton
                //         variant="outline"
                //         shape="square"
                //         size="sm"
                //         color="success"
                //         disabled={props.disableApproveReject}
                //       >
                //         Reject
                //       </CButton>
                //     </td>
                //   );
                // },
                approveBG: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="success"
                        disabled={props.disableApproveReject}
                        onClick={() =>
                          handleApproveCOfirmationOpen(
                            item.lotPaymentId,
                            item.isTransferLotBG,
                            item.paymentId
                          )
                        }
                      >
                        {item.paymentType === 6
                          ? "Approve"
                          : "Generate Agreement"}
                      </CButton>

                      <div>
                        <ConfirmationPopup
                          showModal={bgapproveopen}
                          hideModal={handleApproveCOfirmationClose}
                          confirmModal={approveBGClick}
                          id={0}
                          index={1}
                          ModalBody={"Are you sure you want to Approve?"}
                          // ModalTitle={CPopUpTitle}
                          confirmButtonCss="btn btn-success"
                          ButtonLoader={false}
                        />
                      </div>
                    </td>
                  );
                },
                rejectBG: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="success"
                        disabled={props.disableApproveReject}
                        onClick={() =>
                          handleRejectCOfirmationOpen(
                            item.lotPaymentId,
                            item.isTransferLotBG,
                            item.paymentId
                          )
                        }
                      >
                        Reject
                      </CButton>

                      <div>
                        <ConfirmationPopup
                          showModal={bgrejectopen}
                          hideModal={handleRejectCOfirmationClose}
                          confirmModal={rejectBGClick}
                          id={0}
                          index={1}
                          ModalBody={"Are you sure you want to Reject?"}
                          // ModalTitle={CPopUpTitle}
                          confirmButtonCss="btn btn-success"
                          ButtonLoader={false}
                        />
                      </div>
                    </td>
                  );
                },
                approveExtendAgreement: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="success"
                        disabled={props.disableApproveReject}
                        onClick={() =>
                          handleApproveExtendOpen(item.lotId, item.paymentId)
                        }
                      >
                        Approve
                      </CButton>

                      <div>
                        <ConfirmationPopup
                          showModal={agreementextendOpen}
                          hideModal={handleApproveExtendClose}
                          confirmModal={approveExtendAgreementClick}
                          id={0}
                          index={1}
                          ModalBody={"Are you sure you want to Approve?"}
                          // ModalTitle={CPopUpTitle}
                          confirmButtonCss="btn btn-success"
                          ButtonLoader={false}
                        />
                      </div>
                    </td>
                  );
                },
                rejectExtendAgreement: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="danger"
                        disabled={props.disableApproveReject}
                        onClick={() =>
                          handleRejectExtendOpen(item.lotId, item.paymentId)
                        }
                      >
                        Reject
                      </CButton>

                      <div>
                        <ConfirmationPopup
                          showModal={agreementextendrejectOpen}
                          hideModal={handleRejectExtendClose}
                          confirmModal={rejectExtendAgreementClick}
                          id={0}
                          index={1}
                          ModalBody={"Are you sure you want to Reject?"}
                          // ModalTitle={CPopUpTitle}
                          confirmButtonCss="btn btn-success"
                          ButtonLoader={false}
                        />
                        {/* <Modal
                          open={agreementextendrejectOpen}
                          onClose={handleRejectExtendClose}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                          BackdropComponent={Backdrop}
                        >
                          <Paper style={style} elevation={3}>
                            <CForm
                              className="needs-validation"
                              onSubmit={(e) => {
                                e.preventDefault();
                                handleRejectExtendClose();
                                props.reject(
                                  agreementextendlotid,
                                  agreementextendpaymentid
                                );
                              }}
                            >
                              <CRow>
                                <CCol>
                                  <CLabel>
                                    Are you sure you want to Reject?
                                  </CLabel>
                                </CCol>
                              </CRow>
                              <CRow
                                style={{
                                  marginLeft: "7rem",
                                }}
                              >
                                <CCol xl={3}></CCol>
                                <CCol xl={3}></CCol>
                                <CCol xl={3}>
                                  <CButton
                                    className="mt-3"
                                    color="success"
                                    type="submit"
                                  >
                                    Yes
                                  </CButton>
                                </CCol>
                                <CCol xl={3}>
                                  <CButton
                                    className="mt-3 btn btn-dark"
                                    color="success"
                                    type="button"
                                    onClick={() => handleRejectExtendClose()}
                                  >
                                    No
                                  </CButton>
                                </CCol>
                              </CRow>
                            </CForm>
                          </Paper>
                        </Modal> */}
                      </div>
                    </td>
                  );
                },
                // DownloadSanctionLetterByBidder: (item, index) => {
                //   return (
                //     <td className="py-2">
                //       <CButton
                //         variant="outline"
                //         shape="square"
                //         size="sm"
                //         color="success"
                //         onClick={() =>
                //           handleDownloadSanctionLetterByBidder(
                //             item.tenderId,
                //             item.userId
                //           )
                //         }
                //       >
                //         Download
                //       </CButton>
                //     </td>
                //   );
                // },
                DownloadParidhanAadesh: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="success"
                        onClick={() =>
                          handleDownloadParidhanAadesh(
                            item.lotId,
                            item.lotPaymentId
                          )
                        }
                      >
                        Download
                      </CButton>
                    </td>
                  );
                },
                viewSanctionLetter: (item, index) => {
                  return (
                    <td className="py-2">
                      {item.sanctionLetterPath !== "" ? (
                        <a
                          // href={`http://192.168.1.11/CG_API1/${item.sanctionLetterPath}`}
                          href={`${downloadUrl}/${item.sanctionLetterPath}`}
                          // href={`http://202.131.108.246:82/${item.sanctionLetterPath}`}
                          target="_blank"
                          className="ml-2"
                          rel="noreferrer"
                        >
                          <CButton
                            variant="outline"
                            shape="square"
                            size="sm"
                            color="success"
                          >
                            {props.tabBtn}
                          </CButton>
                        </a>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                },

                viewBGPaymentReceipt: (item, index) => {
                  return (
                    //className="py-2
                    <td>
                      <CButton
                        color="info"
                        onClick={() =>
                          BGPaymentStatusViewHanlder(item.filePath)
                        }
                      >
                        View Receipt
                      </CButton>
                    </td>
                  );
                },

                viewOnlinePaymentReceipt: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        color="info"
                        onClick={() =>
                          PaymentStatusViewHanlder(item.responseMessage)
                        }
                      >
                        View Receipt
                      </CButton>
                    </td>
                  );
                },
                viewcirclereport: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="success"
                        to={`/tendercirclereport/${window.btoa(item.tenderId)}`}
                      >
                        View
                      </CButton>
                    </td>
                  );
                },
                viewBidderDetails: (item, index) => {
                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="success"
                        to={`/bidderlistview/${item.userId}`}
                      >
                        View
                      </CButton>
                    </td>
                  );
                },
                viewAgreementLetter: (item, index) => {
                  return (
                    <td className="py-2">
                      {item.agreementLetterPath !== "" ? (
                        <a
                          // href={`http://192.168.1.11/CG_API1/${item.agreementLetterPath}`}
                          href={`${downloadUrl}/${item.agreementLetterPath}`}
                          // href={`http://202.131.108.246:82/${item.agreementLetterPath}`}
                          target="_blank"
                          className="ml-3"
                          rel="noreferrer"
                        >
                          <CButton
                            variant="outline"
                            shape="square"
                            size="sm"
                            color="success"
                          >
                            {props.tabBtn}
                          </CButton>
                        </a>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                },
                deleteLotDocument: (item, index) => {
                  // {showbtn(props.isAllowToCCFDeleteTheBidderAgreement,item.fileName.toLowerCase())}

                  return (
                    <td className="py-2">
                      <CButton
                        variant="outline"
                        shape="square"
                        size="sm"
                        color="success"
                        hidden={
                          !item.fileName.toLowerCase().includes("signed_")
                        }
                        onClick={() => handleDeleteDocumentOpen(item.id)}
                      >
                        Delete LotDocument
                      </CButton>

                      <div>
                        <Modal
                          open={deletedocumentopen}
                          onClose={handleeDeleteDocumentClose}
                          aria-labelledby="modal-modal-title"
                          aria-describedby="modal-modal-description"
                          BackdropComponent={Backdrop}
                        >
                          <Paper style={style} elevation={3}>
                            <CForm
                              className="needs-validation"
                              onSubmit={(e) => {
                                e.preventDefault();
                                handleeDeleteDocumentClose();
                                props.deletedocument(deletedocumentid);
                              }}
                            >
                              <CRow>
                                <CCol>
                                  <CLabel>
                                    Are you sure you want to Delete Document?
                                  </CLabel>
                                </CCol>
                              </CRow>
                              <CRow
                                style={{
                                  marginLeft: "7rem",
                                }}
                              >
                                <CCol xl={3}></CCol>
                                <CCol xl={3}></CCol>
                                <CCol xl={3}>
                                  <CButton
                                    className="mt-3"
                                    color="success"
                                    type="submit"
                                  >
                                    Yes
                                  </CButton>
                                </CCol>
                                <CCol xl={3}>
                                  <CButton
                                    className="mt-3 btn btn-dark"
                                    color="success"
                                    type="button"
                                    onClick={() => handleeDeleteDocumentClose()}
                                  >
                                    No
                                  </CButton>
                                </CCol>
                              </CRow>
                            </CForm>
                          </Paper>
                        </Modal>
                      </div>
                    </td>
                  );
                },
                viewLotDocument: (item, index) => {
                  return (
                    <>
                      {/* {authenticated.role === "CFO" && (
                        <>
                          <td className="py-2">
                            {item.fileName !== "" ? (
                              <a
                                // href={`http://192.168.1.11/CG_API1/${item.agreementLetterPath}`}
                                href={`${downloadUrl}/AgreementLetters/74/${item.fileName}`}
                                // href={`http://202.131.108.246:82/${item.agreementLetterPath}`}
                                target="_blank"
                                className="ml-3"
                              >
                                <CButton
                                  variant="outline"
                                  shape="square"
                                  size="sm"
                                  color="success"
                                >
                                  {props.tabBtn}
                                </CButton>
                              </a>
                            ) : (
                              ""
                            )}
                          </td>
                        </>
                      )} */}

                      <td className="py-2">
                        {item.fileName !== "" ? (
                          <a
                            // href={`http://192.168.1.11/CG_API1/${item.agreementLetterPath}`}
                            href={`${downloadUrl}/${item.documentpath}`}
                            // href={`http://202.131.108.246:82/${item.agreementLetterPath}`}
                            target="_blank"
                            className="ml-3"
                            rel="noreferrer"
                          >
                            <CButton
                              variant="outline"
                              shape="square"
                              size="sm"
                              color="success"
                            >
                              {props.tabBtn}
                            </CButton>
                          </a>
                        ) : (
                          ""
                        )}
                      </td>
                    </>
                  );
                },
                viewTermiationLetter: (item, index) => {
                  return (
                    <td className="py-2">
                      {item.terminationLetterPath !== "" ? (
                        <a
                          // href={`http://192.168.1.11/CG_API1/${item.terminationLetterPath}`}
                          href={`${downloadUrl}/${item.terminationLetterPath}`}
                          // href={`http://202.131.108.246:82/${item.terminationLetterPath}`}
                          target="_blank"
                          className="ml-2"
                          rel="noreferrer"
                        >
                          <CButton
                            variant="outline"
                            shape="square"
                            size="sm"
                            color="success"
                          >
                            {props.tabBtn}
                          </CButton>
                        </a>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                },
                viewTransferLetter: (item, index) => {
                  return (
                    <td className="py-2">
                      {item.transferLetterPath !== "" ? (
                        <a
                          // href={`http://192.168.1.11/CG_API1/${item.agreementLetterPath}`}
                          href={`${downloadUrl}/${item.transferLetterPath}`}
                          // href={`http://202.131.108.246:82/${item.agreementLetterPath}`}
                          target="_blank"
                          className="ml-3"
                          rel="noreferrer"
                        >
                          <CButton
                            variant="outline"
                            shape="square"
                            size="sm"
                            color="success"
                          >
                            {props.tabBtn}
                          </CButton>
                        </a>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                },
                payAdhoc: (item, index) => {
                  return (
                    <td className="py-2">
                      {item.lotNo !== null ? (
                        <CButton
                          variant="outline"
                          size="sm"
                          color="info"
                          className="ml-2"
                          onClick={() =>
                            PaymentHanlder(item.lotId, item.amount)
                          }
                        >
                          {props.tabBtn}
                        </CButton>
                      ) : (
                        ""
                      )}
                    </td>
                  );
                },
              }}
            />
          </CCol>
        </CRow>
        <CRow className="float-right mt-2">
          <CButton
            className="m-2"
            color="success"
            onClick={props.prev}
            disabled={props.disabledprev}
            style={{ visibility: props.disabledprev ? "hidden" : "visible" }}
          >
            Prev
          </CButton>
          <CButton
            className="m-2"
            color="success"
            onClick={props.next}
            disabled={props.disablednext}
            style={{ visibility: props.disablednext ? "hidden" : "visible" }}
          >
            Next
          </CButton>
        </CRow>
        <div>{props.deleteBtn} </div>
        {props.markedResult}
      </CCardHeader>
    </>
  );
});

export default CommonList;
